import { faEdit, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ColumnDescription } from "react-bootstrap-table-next";
import { Link } from "react-router-dom";
import ModalComponent from "../../../../Components/Modais";
import Table from "../../../../Components/Table";
import {
    AtualizarReguaController,
    DeletarReguaController,
    ListarReguaController,
} from "../../../../Controllers/Automacao/Regua/GestaoDeRegua/GestaoDeReguaControllers";
import { IRegua } from "../../../../Interfaces/Automacao/Regua/GestaoDeRegua/GestaoDeReguaInterfaces";
import { ACESSOS } from "../../../../Routes/Acessos";
import { AlertConfirm } from "../../../../Tools/SweetAlerts";
import CadastrarRegua from "./CadastrarRegua";

export function GestaoDasReguas() {
    const [LstRegua, setLstRegua] = useState<Array<IRegua>>();

    const [show, setShow] = useState(false);

    useEffect(() => {
        updateList();
    }, []);

    function updateList() {
        ListarReguaController().then((res) => setLstRegua(res));
    }

    const columns: Array<ColumnDescription> = [
        {
            dataField: "DS_NOME_REGUA",
            text: "Nome",
            formatter: (cell, row) => (
                <RowGestaoRegua {...row} updateList={updateList} />
            ),
        },
    ];

    return (
        <div className="card">
            <div className="card-header border-0 pb-0 d-flex g-4 flex-wrap justify-content-between">
                <h3 className="card-title align-items-start flex-column mb-0">
                    <span className="card-label font-weight-bolder text-dark gruposTitle">
                        Gestão de Réguas de Cobrança
                    </span>
                </h3>
                <div className="card-toolbar text-right flex-grow-1">
                    <button
                        className="btn btn-success font-weight-bold mr-2"
                        onClick={() => {
                            setShow(true);
                        }}
                    >
                        <FontAwesomeIcon
                            icon={faPlus}
                            size="lg"
                            className="mr-2"
                        />{" "}
                        Nova Régua
                    </button>
                </div>
            </div>
            <div className="card-body">
                {LstRegua && (
                    <Table
                        columns={columns}
                        data={LstRegua}
                        keyField="ID_CASO_COBRANCA_REGUA"
                    />
                )}
            </div>

            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={{
                    noHeader: true,
                    noFooter: true,
                }}
            >
                <CadastrarRegua
                    then={() => {
                        setShow(false);
                        updateList();
                    }}
                />
            </ModalComponent>
        </div>
    );
}

function RowGestaoRegua(props: IRegua & { updateList: () => void }) {
    const { updateList, ...row } = props;

    return (
        <div className="rowCapys">
            <div>
                <h4>{row.DS_NOME_REGUA}</h4>
                <div className="StatusUser">
                    {row.FL_ATIVO ? (
                        <span className="label abel-pill label-inline label-success mr-2">
                            Ativado
                        </span>
                    ) : (
                        <span className="label label-danger abel-pill label-inline mr-2">
                            Desativado
                        </span>
                    )}

                    {row.FL_VALIDADO ? (
                        <span className="label abel-pill label-inline label-success mr-2">
                            Produção
                        </span>
                    ) : (
                        <span className="label abel-pill label-inline label-success mr-2">
                            Homologação
                        </span>
                    )}
                </div>
            </div>
            <div className="col-tools">
                <div className="toolsTable">
                    <label className="text-white">Capys Tools</label>
                    <div className="tools-capys">
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="tooltip-disabled">
                                    {row.FL_ATIVO
                                        ? "Desativar Régua"
                                        : "Ativar Régua"}
                                </Tooltip>
                            }
                        >
                            <span
                                className="switch switch-outline switch-sm switch-icon switch-success"
                                data-toggle="tooltip"
                            >
                                <label>
                                    <input
                                        checked={row.FL_ATIVO}
                                        type="checkbox"
                                        onChange={() => {
                                            AtualizarReguaController({
                                                ...row,
                                                FL_ATIVO: !row.FL_ATIVO,
                                            }).then(() => {
                                                updateList();
                                            });
                                        }}
                                    />
                                    <span></span>
                                </label>
                            </span>
                        </OverlayTrigger>
                    </div>
                </div>
                <div className="Button-Tools">
                    <Link
                        type="button"
                        className="btn btn-outline-primary font-weight-bold mr-2"
                        to={ACESSOS.AUTOMACAO.TELAS.REGUA.EDITAR.DS_LINK(
                            row.ID_CASO_COBRANCA_REGUA as number
                        )}
                    >
                        <FontAwesomeIcon icon={faEdit} size="lg" /> Editar
                    </Link>
                    <button
                        className="btn btn-outline-danger font-weight-bold mr-2"
                        onClick={() => {
                            AlertConfirm(
                                "Deseja apagar essa régua de cobrança?"
                            ).then((result) => {
                                if (
                                    result.isConfirmed &&
                                    row.ID_CASO_COBRANCA_REGUA
                                ) {
                                    DeletarReguaController(
                                        row.ID_CASO_COBRANCA_REGUA
                                    ).then(() => {
                                        updateList();
                                    });
                                }
                            });
                        }}
                    >
                        <FontAwesomeIcon icon={faTrash} size="lg" /> Excluir
                    </button>
                </div>
            </div>
        </div>
    );
}
